import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function PenjalisteIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PenjalisteIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">

      <path fill="#FFFFFF" d="M71.4,11.9l-0.5,3.3c-0.1,0.7-0.3,1.7-0.6,2.9c-0.5-1.6-1.5-2.9-2.9-3.8c-1.5-1-3.4-1.3-5.2-0.9
	c-1.7,0.4-3.2,1.5-4.1,3l-3.9,6.2C52.5,20.4,49.9,19,47,19c-5,0-9,4.1-9,9c0,1.6,0.4,3.1,1.2,4.4L35.3,34l-3.6-5.5
	c-2-3.1-6.2-4-9.3-2l0,0c-1.5,1-2.5,2.5-2.9,4.3c-0.4,1.8-0.1,3.6,0.9,5.1l0,0L27,46c0.8,1.3,2.1,2.3,3.6,2.8
	c1.5,0.5,3.1,0.4,4.6-0.2l2.4-0.9V54l-10,22.9c-1.6,3.6,0,7.9,3.5,9.9c1.9,1,4,1.3,6,0.6c1.9-0.6,3.3-2,4.1-3.8L48.5,67v22.5h9.8V67
	l0.1,0.6c0.8,3.3,3.8,5.5,7.1,5.5c0.6,0,1.1-0.1,1.7-0.2l0,0c1.9-0.5,3.5-1.6,4.5-3.3c1-1.7,1.3-3.6,0.9-5.5l0,0L69.3,51
	c-0.4-1.7-1.5-3.3-3.1-4.3c0.9-1,1.8-2,2.7-3.1c2.5-3.2,4.7-7.1,6.6-11.5c1.8-4.1,3-7.9,3.7-10.3c0.3-1,1.6-6.3,1.6-9.9
	C80.8,11.9,71.4,11.9,71.4,11.9z"/>
      <path fill="#FF0000" d="M56.7,49.2c14.4-7.1,19.9-31.5,19.9-33.6h-2C74,20.8,67.8,41.1,56.7,47V49.2z M47.1,33.3
	c2.9,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2s-5.2,2.4-5.2,5.2S44.2,33.3,47.1,33.3z M54.5,63.1l-2.2,1v21.5h2.2V63.1z M54.5,52.6v2.2
	H41.4L31.1,78.4c-0.8,1.8,0.1,4.1,1.9,5.1s4,0.4,4.7-1.3l8.4-19.3c0.7,0.2,1.5,0.3,2.4,0.3c0.7,0,1.5-0.2,2.1-0.4l9.4-4.4l2.1,8.3
	c0.4,1.8,2.3,3,4.2,2.5c1.8-0.5,3-2.3,2.5-4.2l-3.3-13c-0.5-1.9-2.7-3.3-4.5-2.5L54.5,52.6V40.4l11.7-18.8c0.9-1.4,0.5-3.2-0.9-4.1
	s-3.2-0.4-4,0.9l-10,16h-6c-0.4,0-0.8,0.1-1.1,0.2l-10.4,4.1l-5.4-8.1c-0.9-1.4-2.7-1.8-4.1-0.9s-1.8,2.7-0.9,4.1l6.7,10.1
	c0.7,1.2,2.3,1.7,3.6,1.1l7.6-3v10.5L54.5,52.6L54.5,52.6z"/>
    </svg>
  </SvgIcon>
}

export default PenjalisteIcon;
